(function () {
  function reveal(el) {
    if (el) el.classList.add('is-visible');
  }

  function initElfinkJourney(root) {
    if (!root || root.dataset.ejInit === 'true') return;
    root.dataset.ejInit = 'true';

    var steps = root.querySelectorAll('.elfink-step');
    var cta = root.querySelector('.elfink-journey__cta-wrap');
    var targets = [];

    steps.forEach(function (el) { targets.push(el); });
    if (cta) targets.push(cta);

    if (!('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: [0, 0.08, 0.2], rootMargin: '80px 0px 80px 0px' }
    );

    targets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < vh * 0.95 && rect.bottom > 0) {
        reveal(el);
      } else {
        observer.observe(el);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-elfink-journey]').forEach(initElfinkJourney);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-elfink-journey]')
      : null;
    if (section) {
      section.dataset.ejInit = 'false';
      initElfinkJourney(section);
    }
  });
})();
